export const faqSectionData = [
  {
    question: 'Что такое YouHelp?',
    answer: [
      'YouHelp — не агентство. Это Online-сервис, который помогает студентам и не только найти полезную подработку, а родителям — быстро найти няню.',
    ],
  },
  {
    question: 'Кто такой бебиситтер?',
    answer: [
      'Бебиситтеры — почасовые помощники, чаще всего молодые девушки и юноши, нередко студенты. Они легко находят общий язык с детьми, любят играть, рисовать, танцевать, устраивать домашние спектакли и с радостью ползают по полу. Им можно доверить забрать ребёнка из школы, сопроводить на кружки, поиграть до возвращения родителей. Они работают неполный день, не ищут постоянной занятости, но готовы регулярно заниматься с одним ребёнком. В отличие от профессиональных нянь, у них масса интересов — и это делает общение с ними живым и увлекательным. Вместо бесконечных поисков "няня на час СПБ" или "почасовая няня МСК" вы просто знаете, к кому обратиться.',
    ],
  },
  {
    question: 'Что я получу после регистрации на сайте YouHelp?',
    answer: [
      'После регистрации на сайте вы получите доступ ко всей базе нянь YouHelp. Вы сможете находить свободных помощников на удобное вам время, просматривать анкеты и отзывы, а также размещать объявления и откликаться на кандидатов. Все основные функции сервиса доступны бесплатно — вы можете пользоваться платформой без ограничений и посредников.',
    ],
  },
  {
    question: 'Какие гарантии вы предоставляете?',
    answer: [
      'YouHelp — это информационный сервис, мы не агентство. Вы сами выбираете помощника, а мы лишь рекомендуем. Например, советуем обращать внимание на бебиситтеров, прошедших школу YouHelp — их легко узнать по значку с "школа YouHelp". Каждого ситтера мы проверяем: сначала изучаем его страницы в соцсетях, затем проводим интервью по телефону, после этого — обучение и тестирование под наблюдением психолога. Надёжность документов проверяется через сервис SpectrumData. После работы с няней родители могут оставить отзыв — на основе оценок и количества заказов формируется рейтинг. Но окончательный выбор всегда остаётся за вами.',
    ],
  },
  {
    question: 'Как оформить платный доступ?',
    answer: [
      'Когда вы захотите написать няне или позвать её — мы попросим вас привязать карту. После этого вы сможете выбрать один из двух способов работы с YouHelp — подписка или комиссия за заказ.',
    ],
  },
  {
    question: 'Зачем мне это нужно?',
    answer: [
      'Няня заболела в самый неподходящий момент? Ребёнка надо отвести на занятия? Провести время вдвоем без детей? Поспать пару часов днем, пока дети гуляют? Сделать маникюр или сходить в кино? Погулять вечером, когда дети заснули? Да просто помочь вам с детьми в любое время — для этого и есть YouHelp.',
    ],
  },
  {
    question: 'Как связаться со специалистом?',
    answer: [
      'Чтобы связаться со специалистом, необходимо зарегистрироваться и войти в свой аккаунт. Вы сможете написать кандидату в чат сервиса или откликнуться на его анкету.',
    ],
  },
];
